<template>
  <div class="map-container">
    <i class="icon left" @click="$emit('change-map', 'LEFT')" />
    <i class="icon right" @click="$emit('change-map', 'RIGHT')" />
    <div class="map" v-if="mapType === 'MAP'">
      <Map class="map" />
      <MapTip class="map-tip" />
    </div>
    <div v-else-if="mapType === 'GLOBLE'" class="globle">
      <Globle :lines="lines" />
    </div>
    <div v-else class="china">
      <China :lines="lines" />
    </div>
  </div>
</template>
<script>
import Map from './Map'
import MapTip from './MapTip'
import Globle from './Globle'
import China from './China'
export default {
  components: {
    Map,
    MapTip,
    Globle,
    China
  },
  props: {
    mapType: String,
    lines: Array
  },
  created () {

  }
}
</script>

<style scoped lang="less">
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  .map {
    width: 100%;
    height: 100%;
  }
  .globle {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .china {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .map-tip {
    position: absolute;
    width: 24%;
    height: 30%;
    bottom: 5%;
    left: 5%;
  }
  &:hover {
    .icon {
      cursor: pointer;
      position: absolute;
      z-index: 100000;
      display: block;
      top: 50%;
      height: 60px;
      width: 60px;
      background-image: url('~@/assets/right.png');
      background-repeat: no-repeat;
    }
    .left {
      left: 3%;
      transform: rotate(180deg) translateY(50%);
    }
    .right {
      right: 3%;
      transform: translateY(-50%);
    }
  }
}
</style>
